import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AuthProvider from "./store/Auth";
import DialogProvider from "./hooks/useDialog/DialogProvider";

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <DialogProvider>
        <App />
      </DialogProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
